import { useEffect, useState } from "react";
import { Occurrence } from "../../../../../../models/occurrence";
import useServiceBay from "../../../../../../hooks/useServiceBay";
import { ServiceBaySchedule } from "../../../../../../models/serviceBay";
import useDealership from "../../../../../../hooks/useDealership";
import { deleteServiceBaySchedule } from "../../../../../../api/serviceBay";
import { ServiceBayScheduleDialog, IServiceBayScheduleForm } from "./dialogs/serviceBayScheduleDialog";
import moment from "moment";

interface IServiceBayScheduleCardProps {
    occurrence?: Occurrence;
    setServiceBaySchedule: (data?: ServiceBaySchedule) => void;
    disabled?: boolean;
}

const ServiceBayScheduleCard = (props: IServiceBayScheduleCardProps) => {
    const {
        scheduleServiceBays,
        serviceBays,
    } = useServiceBay();

    const [isOpen, setIsOpen] = useState(false);

    const { getDealershipByDN, dealership } = useDealership();

    useEffect(() => {
        if (props.occurrence?.dealershipDn) {
            getDealershipByDN(props.occurrence.dealershipDn);
        }
    }, [props.occurrence?.dealershipDn]);

    return (
        <>
            <div className="flex flex-col w-full gap-6 my-6 p-6 border rounded">
                <span className="text-color-dark dark:text-white">Box de reparo<b>{props.occurrence?.serviceBaySchedule ? ': ' + props.occurrence?.serviceBaySchedule?.serviceBay?.name : ''}</b></span>
                <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between sm:gap-[25px] w-full">
                    <div className="flex justify-between w-full gap-8 items-center">
                        <div className="flex flex-col w-full gap-4 sm:flex-row sm:justify-between sm:items-center sm:gap-8">
                            <div className="flex items-center justify-center p-2 border rounded w-[100px] h-[40px]">
                                <img
                                    src="/assets/images/clipboard.svg"
                                    alt=""
                                    style={{ width: 18, height: 18 }}
                                />
                            </div>
                            <div className="flex flex-col w-full">
                                <span className="text-color-dark dark:text-white font-semibold text-size-14">
                                    Data de atualização
                                </span>
                                <span className="text-color-dark dark:text-white text-size-14">
                                    {props.occurrence?.serviceBaySchedule ? props.occurrence?.updatedAt?.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" }) : '-'}
                                </span>
                            </div>
                            <div className="flex w-full items-center justify-start px-[10px] gap-2 h-[48px] bg-[#1a1a1a] border-2 border-[#31b5c0] rounded">
                                <span className="rioglyph rioglyph-time-alt bg-[#1a1a1a] p-2 border rounded text-[#31b5c0]" />
                                <span className="font-semibold ml-4 text-white">
                                    {
                                        [
                                            props.occurrence?.serviceBaySchedule?.startDate?.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),
                                            props.occurrence?.serviceBaySchedule?.endDate?.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
                                        ].join(' - ') ?? '-'
                                    }
                                </span>
                            </div>
                            <div className="flex w-full items-center justify-start px-[10px] gap-2 h-[48px] bg-[#1a1a1a] border-2 border-[#31b5c0] rounded">
                                <span className="rioglyph rioglyph-workshop bg-[#1a1a1a] p-2 border rounded text-[#31b5c0]" />
                                <span className="font-semibold ml-4 text-white">{props.occurrence?.serviceBaySchedule ? dealership?.name : "-"}</span>
                            </div>
                        </div>
                        {props.disabled ? null : <button
                            type="button"
                            className="btn btn-lg btn-primary h-[48px] w-full sm:w-[500px] text-size-16"
                            onClick={() => setIsOpen(true)}
                            aria-label="Box de reparo"
                        >
                            {props.occurrence?.serviceBaySchedule ? 'Ver agendamento' : 'Agendar Box'}
                        </button>}
                    </div>
                </div>
            </div>

            <ServiceBayScheduleDialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                onDelete={async () => {
                    if (props.occurrence?.serviceBaySchedule?.id) {
                        await deleteServiceBaySchedule(props.occurrence.serviceBaySchedule.id);
                    }
                    props.setServiceBaySchedule(undefined);
                }}
                scheduleServiceBays={scheduleServiceBays}
                serviceBays={serviceBays}
                occurrence={props.occurrence ?? undefined}
                setServiceBaySchedule={(data?: IServiceBayScheduleForm) => {
                    const startTime = data?.startTime;
                    const endTime = data?.endTime;

                    props.setServiceBaySchedule(data ? {
                        startDate: startTime,
                        endDate: endTime,
                        serviceBay: data.serviceBay ? serviceBays.find(serviceBay => serviceBay.id === data.serviceBay) : undefined,
                        occurrence: data.occurrence ? props.occurrence : undefined,
                    } : undefined);
                }}
            />
        </>
    );
};

export default ServiceBayScheduleCard;